import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LogRocketService } from '../services/log-rocket.service';

@Injectable()
export class LogRocketInterceptor implements HttpInterceptor {
  constructor(private logRocketService: LogRocketService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((data) => {
        if (data instanceof HttpErrorResponse) {
          this.checkErrorCodeAndHandleLogging(data);
        }
      }),
      catchError((data) => {
        if (data instanceof HttpErrorResponse) {
          this.checkErrorCodeAndHandleLogging(data);
        }

        return throwError(data);
      }),
    );
  }

  private checkErrorCodeAndHandleLogging(data: HttpErrorResponse): void {
    if (data.status !== 0 && data.status !== 400 && data.status !== 401 && data.status !== 403) {
      this.logRocketService.logError(data);
    }
  }
}
